
var DTF_COLORS=[
  {name:'Blanco',img:'https://cdn.shopify.com/s/files/1/0994/4829/1702/t/3/assets/dtf-shirt-blanco.png?v=1779703976',hex:'#FFFFFF'},
  {name:'Negro',img:'https://cdn.shopify.com/s/files/1/0994/4829/1702/t/3/assets/dtf-shirt-negro.png?v=1779703978',hex:'#1A1A1A'},
  {name:'Amarillo',img:'https://cdn.shopify.com/s/files/1/0994/4829/1702/t/3/assets/dtf-shirt-amarillo.png?v=1779703980',hex:'#F1C40F'},
  {name:'Arena',img:'https://cdn.shopify.com/s/files/1/0994/4829/1702/t/3/assets/dtf-shirt-arena.png?v=1779703982',hex:'#D4B896'},
  {name:'Camuflaje',img:'https://cdn.shopify.com/s/files/1/0994/4829/1702/t/3/assets/dtf-shirt-camuflaje.png?v=1779703984',hex:'#6B7C4A'},
  {name:'Celeste',img:'https://cdn.shopify.com/s/files/1/0994/4829/1702/t/3/assets/dtf-shirt-celeste.png?v=1779703986',hex:'#87CEEB'},
  {name:'Granate',img:'https://cdn.shopify.com/s/files/1/0994/4829/1702/t/3/assets/dtf-shirt-granate.png?v=1779703988',hex:'#800020'},
  {name:'Gris Plomo',img:'https://cdn.shopify.com/s/files/1/0994/4829/1702/t/3/assets/dtf-shirt-gris-plomo.png?v=1779703990',hex:'#808080'},
  {name:'Gris Vigore',img:'https://cdn.shopify.com/s/files/1/0994/4829/1702/t/3/assets/dtf-shirt-gris-vigore.png?v=1779703992',hex:'#ADADAD'},
  {name:'Lila',img:'https://cdn.shopify.com/s/files/1/0994/4829/1702/t/3/assets/dtf-shirt-lila.png?v=1779703994',hex:'#9B59B6'},
  {name:'Magenta',img:'https://cdn.shopify.com/s/files/1/0994/4829/1702/t/3/assets/dtf-shirt-magenta.png?v=1779703996',hex:'#C2185B'},
  {name:'Marino',img:'https://cdn.shopify.com/s/files/1/0994/4829/1702/t/3/assets/dtf-shirt-marino.png?v=1779703999',hex:'#1B2A4A'},
  {name:'Morado',img:'https://cdn.shopify.com/s/files/1/0994/4829/1702/t/3/assets/dtf-shirt-morado.png?v=1779704001',hex:'#6C3483'},
  {name:'Naranja',img:'https://cdn.shopify.com/s/files/1/0994/4829/1702/t/3/assets/dtf-shirt-naranja.png?v=1779704003',hex:'#E67E22'},
  {name:'Oceano',img:'https://cdn.shopify.com/s/files/1/0994/4829/1702/t/3/assets/dtf-shirt-oceano.png?v=1779704005',hex:'#006994'},
  {name:'Rojo',img:'https://cdn.shopify.com/s/files/1/0994/4829/1702/t/3/assets/dtf-shirt-rojo.png?v=1779704007',hex:'#C0392B'},
  {name:'Rosa',img:'https://cdn.shopify.com/s/files/1/0994/4829/1702/t/3/assets/dtf-shirt-rosa.png?v=1779704009',hex:'#F9A8D4'},
  {name:'Rosa Palido',img:'https://cdn.shopify.com/s/files/1/0994/4829/1702/t/3/assets/dtf-shirt-rosa-palido.png?v=1779704011',hex:'#FADADD'},
  {name:'Azul Royal',img:'https://cdn.shopify.com/s/files/1/0994/4829/1702/t/3/assets/dtf-shirt-azul-royal.png?v=1779704013',hex:'#2980B9'},
  {name:'Tejano',img:'https://cdn.shopify.com/s/files/1/0994/4829/1702/t/3/assets/dtf-shirt-tejano.png?v=1779704015',hex:'#5B7FA6'},
  {name:'Turquesa',img:'https://cdn.shopify.com/s/files/1/0994/4829/1702/t/3/assets/dtf-shirt-turquesa.png?v=1779704017',hex:'#1ABC9C'},
  {name:'Verde Botella',img:'https://cdn.shopify.com/s/files/1/0994/4829/1702/t/3/assets/dtf-shirt-verde-botella.png?v=1779704020',hex:'#1B4D2E'},
  {name:'Verde Kelly',img:'https://cdn.shopify.com/s/files/1/0994/4829/1702/t/3/assets/dtf-shirt-verde-kelly.png?v=1779704022',hex:'#27AE60'},
  {name:'Verde Manzana',img:'https://cdn.shopify.com/s/files/1/0994/4829/1702/t/3/assets/dtf-shirt-verde-manzana.png?v=1779704024',hex:'#8BC34A'},
  {name:'Verde Militar',img:'https://cdn.shopify.com/s/files/1/0994/4829/1702/t/3/assets/dtf-shirt-verde-militar.png?v=1779704026',hex:'#4E5D2F'},
  {name:'Verde Menta',img:'https://cdn.shopify.com/s/files/1/0994/4829/1702/t/3/assets/dtf-shirt-verde-menta.png?v=1779704028',hex:'#A8D8C0'},
  {name:'Coral',img:'https://cdn.shopify.com/s/files/1/0994/4829/1702/t/3/assets/dtf-shirt-coral.png?v=1779704031',hex:'#FF6B6B'},
  {name:'Rojo Teja',img:'https://cdn.shopify.com/s/files/1/0994/4829/1702/t/3/assets/dtf-shirt-rojo-teja.png?v=1779704033',hex:'#8B2500'},
  {name:'Mandarina',img:'https://cdn.shopify.com/s/files/1/0994/4829/1702/t/3/assets/dtf-shirt-mandarina.png?v=1779704035',hex:'#FF8C00'}
];

var dtfC=null,dtfS=null,dtfP='l',dtfQty=1,PB=9.95,PD=5.00;

document.addEventListener('DOMContentLoaded',function(){
  var sc=document.getElementById('dtf-swatches');
  if(!sc) return;
  DTF_COLORS.forEach(function(c,i){
    var d=document.createElement('div');
    d.className='dtf-sw'+(i===0?' sel':'');
    d.style.background=c.hex;
    d.style.borderColor=c.hex==='#FFFFFF'?'#ddd':c.hex;
    d.dataset.n=c.name;
    d.onclick=function(){dtfPickC(c,d);};
    sc.appendChild(d);
  });
  dtfPickC(DTF_COLORS[0],sc.querySelector('.dtf-sw'));
});

function dtfPickC(c,el){
  document.querySelectorAll('.dtf-sw').forEach(function(s){s.classList.remove('sel');});
  el.classList.add('sel');
  dtfC=c;
  document.getElementById('dtf-cname').textContent=c.name;
  document.getElementById('dtf-cc').textContent=c.name;
  dtfLoadShirt(c.img,c.hex);
}

function dtfShade(h,p){
  var n=parseInt(h.replace('#',''),16);
  var r=Math.min(255,Math.max(0,(n>>16)+p));
  var g=Math.min(255,Math.max(0,((n>>8)&255)+p));
  var b=Math.min(255,Math.max(0,(n&255)+p));
  return '#'+((1<<24)+(r<<16)+(g<<8)+b).toString(16).slice(1);
}

function dtfLoadShirt(url,hex){
  var img=document.getElementById('dtf-shirt');
  img.style.opacity='0.3';
  var tmp=new Image();
  tmp.crossOrigin='anonymous';
  tmp.onload=function(){
    img.src=url;
    img.style.opacity='1';
    img.style.display='block';
  };
  tmp.onerror=function(){
    dtfFallback(hex);
  };
  tmp.src=url;
}

function dtfFallback(hex){
  var img=document.getElementById('dtf-shirt');
  var d1=dtfShade(hex,-15),d2=dtfShade(hex,-25);
  var svg='<svg viewBox="0 0 200 220" xmlns="http://www.w3.org/2000/svg"><defs><linearGradient id="g" x1="0" y1="0" x2="1" y2="0"><stop offset="0%" stop-color="rgba(0,0,0,0.05)"/><stop offset="100%" stop-color="rgba(0,0,0,0.08)"/></linearGradient></defs><path d="M60 36 L18 68 L34 78 L29 192 L171 192 L166 78 L182 68 L140 36 Q120 21 100 23 Q80 21 60 36Z" fill="'+hex+'"/><path d="M60 36 L18 68 L34 78 L50 57Z" fill="'+d1+'"/><path d="M140 36 L182 68 L166 78 L150 57Z" fill="'+d1+'"/><path d="M80 36 Q100 50 120 36 Q110 27 100 26 Q90 27 80 36Z" fill="'+d2+'"/><path d="M60 36 L18 68 L34 78 L29 192 L171 192 L166 78 L182 68 L140 36 Q120 21 100 23 Q80 21 60 36Z" fill="url(#g)"/></svg>';
  img.src='data:image/svg+xml;base64,'+btoa(unescape(encodeURIComponent(svg)));
  img.style.opacity='1';
  img.style.display='block';
}

function dtfSize(el,s){
  document.querySelectorAll('.dtf-sp').forEach(function(b){b.classList.remove('sel');});
  el.classList.add('sel');dtfS=s;
  document.getElementById('dtf-cs').textContent=s;
}

function dtfPos(el,p,lbl){
  document.querySelectorAll('.dtf-pp').forEach(function(b){b.classList.remove('sel');});
  el.classList.add('sel');dtfP=p;
  document.getElementById('dtf-cp').textContent=lbl;
  ['l','c','b'].forEach(function(z){
    var dz=document.getElementById('dtf-dz-'+z);
    if(dz) dz.classList.toggle('on',z===p);
  });
  if(p==='b') dtfView('back',document.querySelector('.dtf-vbtn:last-child'));
  else dtfView('front',document.querySelector('.dtf-vbtn:first-child'));
}

function dtfView(v,el){
  if(el){document.querySelectorAll('.dtf-vbtn').forEach(function(b){b.classList.remove('active');});el.classList.add('active');}
}

function dtfFile(inp){
  var f=inp.files[0];if(!f)return;
  document.getElementById('dtf-uparea').classList.add('done');
  var ok=document.getElementById('dtf-uok');
  ok.style.display='block';ok.textContent='✓ '+f.name;
  var r=new FileReader();
  r.onload=function(e){
    ['l','c','b'].forEach(function(z){
      var img=document.getElementById('dtf-di-'+z);
      if(img){img.src=e.target.result;img.style.display='block';}
      var ph=document.getElementById('dtf-dp-'+z);
      if(ph) ph.style.display='none';
    });
  };
  r.readAsDataURL(f);
}

function dtfTxt(){
  var t=document.getElementById('dtf-txtin').value;
  var f=document.getElementById('dtf-txfont').value;
  var c=document.getElementById('dtf-txcolor').value;
  var s=document.getElementById('dtf-txsz').value;
  ['l','c','b'].forEach(function(z){
    var el=document.getElementById('dtf-dt-'+z);
    var ph=document.getElementById('dtf-dp-'+z);
    if(!el)return;
    if(t){el.style.display='block';el.textContent=t;el.style.fontFamily=f;el.style.color=c;el.style.fontSize=s+'px';if(ph)ph.style.display='none';}
    else{el.style.display='none';if(ph)ph.style.display='';}
  });
}

function dtfTxtSz(){
  var s=document.getElementById('dtf-txsz').value;
  document.getElementById('dtf-szv').textContent=s+'px';
  dtfTxt();
}

function dtfQ(d){
  dtfQty=Math.max(1,dtfQty+d);
  document.getElementById('dtf-qn').textContent=dtfQty;
  document.getElementById('dtf-qx').textContent=dtfQty;
  document.getElementById('dtf-tot').textContent=((PB+PD)*dtfQty).toFixed(2).replace('.',',')+' €';
}

function dtfCart(){
  if(!dtfC){alert('Por favor selecciona un color.');return;}
  if(!dtfS){alert('Por favor selecciona una talla.');return;}
  var hasD=document.getElementById('dtf-fin').files.length>0||document.getElementById('dtf-txtin').value.trim();
  if(!hasD&&!confirm('No has añadido diseño. ¿Continuar?'))return;
  var total=((PB+PD)*dtfQty).toFixed(2).replace('.',',');
  var cp=document.getElementById('dtf-cp').textContent;
  document.getElementById('dtf-mdet').innerHTML='<div class="dtf-mdr"><span>Producto</span><strong>Camiseta DTF</strong></div><div class="dtf-mdr"><span>Color</span><strong>'+dtfC.name+'</strong></div><div class="dtf-mdr"><span>Talla</span><strong>'+dtfS+'</strong></div><div class="dtf-mdr"><span>Posición</span><strong>'+cp+'</strong></div><div class="dtf-mdr"><span>Cantidad</span><strong>'+dtfQty+' uds.</strong></div><div class="dtf-mdr"><span>Total</span><strong>'+total+' €</strong></div>';
  document.getElementById('dtf-modal').classList.add('show');
}

function dtfQuote(){alert('Solicitar presupuesto:\nnuestrosuministro@gmail.com\n699 028 756');}
function dtfCloseM(){document.getElementById('dtf-modal').classList.remove('show');}
function dtfGoCart(){dtfCloseM();window.location.href='/cart';}
